import SimpleElementBuilder from '@/Builder/SimpleElementBuilder';
import EventHelper from '@/Utility/EventHelper';

export default class SimpleCheckboxBuilder extends SimpleElementBuilder {
    private isChecked: boolean;
    private isReadonly: boolean;
    private onCheck: (checked) => void;

    private _wrapper: HTMLElement;
    private _inner: HTMLDivElement;

    public constructor() {
        super();
        this.isChecked = false;
    }

    public withIsChecked(isChecked: boolean): this {
        this.isChecked = isChecked;
        return this;
    }

    public withIsReadonly(isReadonly: boolean): this {
        this.isReadonly = isReadonly;
        return this;
    }

    public withOnCheck(onCheck: (checked) => void): this {
        this.onCheck = onCheck;
        return this;
    }

    public buildAndGetElement(): HTMLElement {
        this._wrapper = this.element || document.createElement('div');
        this._wrapper.classList.add('c-checkbox');
        
        this._inner = document.createElement('div');
        this._inner.classList.add('element');

        this._wrapper.append(this._inner);

        if (this.locator) 
            this._wrapper.dataset.locator = this.locator;

        this.setCheckedStates(this._wrapper, this._inner);

        if (this.isReadonly) {
            this._wrapper.classList.add('c-state-disabled');
        }
        else {
            EventHelper.bindClickEvent(this._wrapper, this.onCheckInternal.bind(this, this._wrapper, this._inner));
        }

        return this._wrapper;
    }

    private onCheckInternal(wrapper: HTMLElement, inner: HTMLElement) {
        this.isChecked = !this.isChecked;
        this.setCheckedStates(wrapper, inner);
        this.onCheck(this.isChecked);
    }

    private setCheckedStates(wrapper: HTMLElement, inner: HTMLElement) {
        wrapper.setAttribute('data-checked', this.isChecked.toString());

        if (this.isChecked)
            inner.innerText = '✓';
        else
            inner.innerText = '';
    }
}